<template>
  <div class="VacationArchiveDetails">
    <v-dialog v-model="visible">

      <box :title="$t('vacationDetails')">
        <v-row class="pa-2">
          <v-col cols="12" sm="6">
            <v-row>
              <v-col class="max-width-text-title px-1"
                >{{ $t("PageNo") }}:</v-col
              >
              <v-col>
                <span class="text-value">{{ vacation.Pageno }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6">
            <v-row>
              <v-col class="max-width-text-title px-1"
                >{{ $t("RequestedPersonName") }}:</v-col
              >
              <v-col>
                <span class="text-value">{{ vacation.PersonName }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6">
            <v-row>
              <v-col class="max-width-text-title px-1"
                >{{ $t("BeginDate") }}:</v-col
              >
              <v-col>
                <span class="text-value">{{ vacation.BeginDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6">
            <v-row>
              <v-col class="max-width-text-title px-1"
                >{{ $t("BeginTime") }}:</v-col
              >
              <v-col>
                <span class="text-value">{{ vacation.BeginTime }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6">
            <v-row>
              <v-col class="max-width-text-title px-1"
                >{{ $t("EndDate") }}:</v-col
              >
              <v-col>
                <span class="text-value">{{ vacation.EndDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6">
            <v-row>
              <v-col class="max-width-text-title px-1"
                >{{ $t("EndTime") }}:</v-col
              >
              <v-col>
                <span class="text-value">{{ vacation.EndTime }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6">
            <v-row>
              <v-col class="max-width-text-title px-1"
                >{{ $t("requestType") }}:</v-col
              >
              <v-col>
                <span class="text-value">{{ vacation.Name }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6">
            <v-row>
              <v-col class="max-width-text-title px-1"
                >{{ $t("LastChangeDate") }}:</v-col
              >
              <v-col>
                <span class="text-value">{{ vacation.LastChangeDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-divider class="my-2"></v-divider>
            <v-row>
              <v-col class="max-width-text-title px-1"
                >{{ $t("status") }}:</v-col
              >
              <v-col>
                <span
                  class="text-value"
                  v-text="
                    vacation.StatusType +
                    '-' +
                    (details.IsTransfer
                      ? 'انتقال داده شده'
                      : 'انتقال داده نشده')
                  "
                ></span>
              </v-col>
            </v-row>
          </v-col>

          <v-col v-if="pnlRemainVacationVisible" cols="12" sm="12">
            <v-row>
              <v-col cols="12" sm="6">
                <v-row>
                  <v-col class="max-width-text-title px-1"
                    >{{ $t("remainUptoMonth") }}:</v-col
                  >
                  <v-col>
                    <span class="text-value d-ltr">{{ remainUptoMonth }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6">
                <v-row>
                  <v-col class="max-width-text-title px-1"
                    >{{ $t("remainUptoYear") }}:</v-col
                  >
                  <v-col>
                    <span class="text-value">{{ remainUptoYear }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col cols="12" sm="6">
                <v-row>
                  <v-col class="max-width-text-title px-1"
                    >{{ $t("countHourVacations") }}:</v-col
                  >
                  <v-col>
                    <span class="text-value">{{ countHourVacations }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6">
                <v-row>
                  <v-col class="max-width-text-title px-1"
                    >{{ $t("totalHourVacations") }}:</v-col
                  >
                  <v-col>
                    <span class="text-value">{{ totalHourVacations }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col class="max-width-text-title px-1"
                >{{ $t("description") }}:</v-col
              >
              <v-col>
                <span class="text-value">
                  {{ details.PersonName }}:{{ details.UserDescription }} <br />
                  <span
                    >تائید / رد کننده: {{ ApprovedPerson }}
                    {{ details.RejectCommand }}</span
                  >
                </span>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            cols="12"
            v-if="visibleReject || visibleReturn || visibleApprove"
          >
            <v-row>
              <v-col class="max-width-text-title px-1"
                ><span>علت رد / برگشت:</span></v-col
              >
              <v-col
                ><v-textarea
                  solo
                  hide-details=""
                  auto-grow
                  rows="2"
                  placeholder="
                  "
                  dense
                  v-model="txtAdminParaf"
                 
              /></v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-card-actions v-if="showBtn">
          <v-spacer></v-spacer>

          <v-btn small  v-if="visibleReturn" @click="ReturnRequest">{{
            $t("ReturnRequest")
          }}</v-btn>
          <v-btn small  v-if="visibleReject" @click="RejectRequest">{{
            $t("RejectRequest")
          }}</v-btn>
          <v-btn  small  @click="ApproveRequest">{{
            $t("ApproveRequest")
          }}</v-btn>
          <v-btn small v-if="visibleDelete" @click="DeleteRequest">{{
            $t("DeleteRequest")
          }}</v-btn>
          <v-btn small v-if="visibleEdit" @click="EditRequest">{{
            $t("EditRequest")
          }}</v-btn>
        </v-card-actions>

        <archive-detals-flow
          :pageNo="pageNo"
          :pageType="1"
          :year="Number(vacation.Year)"
        />
      </box>
    </v-dialog>
  </div>
</template>

<script>
import RequestState from "@/model/RequestState";
import ArchiveDetalsFlow from "../../request/ArchiveDetalsFlow.vue";
import EosUtils from "../../../utils/EosUtils";
import TextUtils from "../../../utils/TextUtils";
import ResultType from "../../../model/ResultType";

const initialData = () => {
  return {
    visibleBtn:false,
    visible: false,
    vacation: {},
    details: {},
    visibleEdit: false,
    visibleDelete: false,
    visibleReject: false,
    visibleReturn: false,
    visibleApprove: false,
    ApprovedPerson: "",
    txtAdminParaf: "",
    pnlRemainVacationVisible: false,
    remainUptoMonth: "",
    remainUptoYear: "",
    countHourVacations: "",
    totalHourVacations: "",
    showBtn:true,
  };
};

export default {
  components: { ArchiveDetalsFlow },
  props: {
    approved:Boolean,
  },
  computed: {
    pageNo() {
      debugger
      if (this.vacation && this.vacation.Pageno) {
        return this.vacation.Pageno.trim();
      } else {
        return "";
      }
    },
  },
  data() {
    return initialData();
  },
  // mounted() {
  //   debugger
  //   if(this.approved){
  //     this.showBtn=false;
  //     debugger
  //   }

  // },
  methods: {
    resetData() {
      Object.assign(this.$data, initialData());
      if(this.approved){
      this.showBtn=false;
      debugger
    }
    },
    show(vacation) {
      //console.log("vacation:", vacation);
      this.resetData();
      this.visible = true;
      this.vacation = vacation;
      this.GetVacationDetailForPerson(this.vacation);
    },
    hide() {
      this.visible = false;
    },
    GetVacationDetailForPerson(item) {
      debugger
      const params = new URLSearchParams();
      params.append("pageNo", TextUtils.convertToEnglishDigits(item.Pageno));
      params.append("dbkind", "1");
      params.append("year", item.Year);
      params.append("perno", TextUtils.convertToEnglishDigits(item.Perno));
      this.$store
        .dispatch("GetVacationDetailForPerson", { params })
        .then((result) => {
          if (result.type == "success") {
            if (result.data.length > 0) {
              this.details = result.data[0];
              this.checkActionsVisiblity();
              this.getApprovedPerson();
              this.GetVacationRemainDetail();
              this.GetHourlyVacationCountAndLength();
            }
          }
        });
    },
    async GetVacationRemainDetail() {
      var DisableShowingMorLeft = false;
      var readwebkartsettingRes = await this.$store.dispatch(
        "readwebkartsetting"
      );
      if (readwebkartsettingRes.type == ResultType.success) {
        DisableShowingMorLeft =
          readwebkartsettingRes.data.DisableShowingMorLeft == "1";
      }
      if (DisableShowingMorLeft) {
        this.pnlRemainVacationVisible = false;
        return;
      }
      this.pnlRemainVacationVisible = true;

      var moment = require("jalali-moment");
      var year = moment().locale("fa").format("YYYY");
      var date = moment().locale("fa").format("MM/DD");

      var GetRemainMorakhasiUntilNowParams = {
        perno: this.details.PerNo,
        date: date,
        year: year,
      };
      this.$store
        .dispatch("GetRemainMorakhasiUntilNow", {
          GetRemainMorakhasiUntilNowParams,
        })
        .then((result) => {
          console.log(result);
          if (result.type === "success") {
            var remainUptoMonth = result.data[2];
            if (remainUptoMonth < 0) {
              this.remainUptoMonth =
                "-" + EosUtils.ConvertMinToHour(remainUptoMonth.toString());
            } else {
              this.remainUptoMonth = EosUtils.ConvertMinToHour(
                remainUptoMonth.toString()
              );
            }

            var remainUptoYear = result.data[3];
            if (remainUptoYear < 0) {
              this.remainUptoYear =
                "-" + EosUtils.ConvertMinToHour(remainUptoYear.toString());
            } else {
              this.remainUptoYear = EosUtils.ConvertMinToHour(
                remainUptoYear.toString()
              );
            }
          }
        });
    },
    GetHourlyVacationCountAndLength() {
      var moment = require("jalali-moment");
      var year = moment().locale("fa").format("YYYY");
      var date = moment().locale("fa").format("MM/DD");

      var GetHourlyVacationCountAndLengthParams = {
        perno: this.details.PerNo,
        date: date,
        year: year,
      };
      this.$store
        .dispatch("GetHourlyVacationCountAndLength", {
          GetHourlyVacationCountAndLengthParams,
        })
        .then((result) => {
          console.log(result);
          if (result.type === "success") {
            this.countHourVacations = result.data.count;
            this.totalHourVacations = result.data.duration;
          }
        });
    },
    getApprovedPerson() {
      if (this.details.ApprovedPerson.trim() == "-1") {
        this.ApprovedPerson = this.$t("webkartManager");
      } else if (this.details.ApprovedPerson.trim() == "000") {
        this.ApprovedPerson = this.$t("winkartManager");
      } else {
        let params = new URLSearchParams();
        params.append("perno", this.details.ApprovedPerson.trim());
        this.$store.dispatch("GetPersonFullName", { params }).then((result) => {
          if (result.type === ResultType.success) {
            this.ApprovedPerson = result.data;
          }
        });
      }
    },
    checkActionsVisiblity() {
      var params = new URLSearchParams();
      params.append(
        "pagePerno",
        TextUtils.convertToEnglishDigits(this.vacation.Pageno.trim())
      );
      params.append(
        "section",
        TextUtils.convertToEnglishDigits(this.vacation.Section.trim())
      );
      params.append("vacationType", this.vacation.Type);
      params.append("status", this.vacation.Status);
      params.append("txtAdminParaf", this.txtAdminParaf);
      //debugger;
      this.$store
        .dispatch("GetVacationDetailForAdmin", { params })
        .then((result) => {
          if (result.type === ResultType.success) {
            this.visibleEdit = result.data.Edit;
            this.visibleDelete = result.data.Delete;
            this.visibleReject = result.data.Reject;
            this.visibleReturn = result.data.Return;
            this.visibleApprove = result.data.Approve;
          }
        });
    },
    EditRequest() {
      this.hide();
      console.log(this.details);
      console.log(this.vacation);

      var vacationDetails = {
        Year: this.vacation.Year,
        PageNo: TextUtils.convertToEnglishDigits(
          this.vacation.Pageno.toString().trim()
        ),
        //Type: this.details.Type,
        DBKind: 1,
        selectedPerno: TextUtils.convertToEnglishDigits(
          this.vacation.Perno.toString().trim()
        ),
        txtAdminParaf:this.txtAdminParaf,
        
      };

      if (EosUtils.isWebKartAdmin()) {
        vacationDetails.from = "admin-vacation-management";
        this.$router.push({
          name: "admin-request-leave",
          params: { vacationDetails: vacationDetails },
        });
      }
    },
    DeleteRequest() {
      this.operationOnRequest(RequestState.RequestState.Delete);
    },
    ReturnRequest() {
      this.operationOnRequest(RequestState.RequestState.Return);
    },
    RejectRequest() {
      this.operationOnRequest(RequestState.RequestState.Reject);
    },
    ApproveRequest() {
      this.operationOnRequest(RequestState.RequestState.Approve);
    },
    operationOnRequest(requestState) {
       debugger;
      var list = [this.vacation];
      this.$emit("operationOnRequest", requestState, list,this.txtAdminParaf);
      this.hide();
    },
  },
};
</script>

<style scoped>
.max-width-text-title {
  max-width: 200px;
}
</style>